import React, { Component } from "react";

import DarkModeIcon from '@mui/icons-material/DarkMode';

class DarkModeToggle extends Component {
    
    toggleDarkmode() {
        var element = document.body;
        element.classList.toggle("dark-mode");
    }

    render() {   
        return (
            <div onClick={this.toggleDarkmode} className="nav-item flex-right"><DarkModeIcon/></div>
        )
    }
    
    
}
export default DarkModeToggle; 